/** @jsx jsx */
import { css, jsx } from '@emotion/core';
import { gridSize } from '@atlaskit/theme/constants';
import { token } from '@atlaskit/tokens';
import { N0, N30, N40, N800 } from '@atlaskit/theme/colors';
import { COLOR_ROLES } from './color-roles';
import { ColorRole } from './types';

const tableContainerStyles = css({
  listStyle: 'none',
  margin: 0,
  padding: 0,
  display: 'grid',
});

const rowStyles = css({
  display: 'grid',
  gridColumnGap: gridSize() * 2,
  paddingTop: gridSize() * 2,
  paddingBottom: gridSize() * 2,
  gridTemplateColumns: '2fr 8fr',

  '&:not(:last-of-type)': {
    borderBottom: `1px solid ${token('color.border', N30)}`,
  },
});

const tagContainerStyles = css({
  padding: '4px 8px',
  borderRadius: '100px',
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',
  alignItems: 'center',
  width: 'fit-content',
  height: 'fit-content',
});

const colorDotStyles = css({
  width: 16,
  height: 16,
  borderRadius: '50%',
  marginRight: gridSize(),
});

type Props = {
  role: ColorRole;
};

const ColorRolesTable = () => (
  <ul css={tableContainerStyles}>
    <li css={rowStyles}>
      <b>Role</b>
      <b>Description</b>
    </li>
    {COLOR_ROLES.map((role: ColorRole) => {
      const { name, icon, token: iconToken, background, inverse, input } = role;
      return (
        <li key={name} css={rowStyles}>
          <div
            css={tagContainerStyles}
            style={{
              backgroundColor: background,
              border: `1px solid ${
                input ? token('color.border.input', N40) : 'none'
              }`,
            }}
          >
            {icon ? (
              icon
            ) : (
              <div
                css={colorDotStyles}
                style={{
                  backgroundColor: iconToken,
                }}
              />
            )}
            <code
              style={{
                color: inverse
                  ? token('color.text.inverse', N0)
                  : token('color.text', N800),
              }}
            >
              {name}
            </code>
          </div>
          <p style={{ margin: 0, whiteSpace: 'pre-line' }}>
            {role.description}
          </p>
        </li>
      );
    })}
  </ul>
);

export default ColorRolesTable;
